/**
 * Central source of route paths. Import from here rather than hard-coding —
 * makes the eventual rename safe.
 */
export const paths = {
  // Public
  passport: '/passport/:qrToken',

  // Auth
  login: '/login',
  callback: '/callback',
  forbidden: '/forbidden',

  // Post-login landing
  dashboard: '/dashboard',

  // Operational modules (mirrors backend module names)
  customers: '/customers',
  customerCreate: '/customers/new',
  customerDetail: '/customers/:id',
  batteryModels: '/product-models',
  quotations: '/quotations',
  quotationCreate: '/quotations/new',
  quotationDetail: '/quotations/:id',
  salesOrders: '/sales-orders',
  salesOrderCreate: '/sales-orders/new',
  salesOrderDetail: '/sales-orders/:id',
  workOrders: '/work-orders',
  shipments: '/shipments',
  warranty: '/warranty',
  serviceCases: '/service-cases',
  metadata: '/metadata',
  dynamicRecords: '/dynamic-records',
  workflowInbox: '/workflow/inbox',
  registryAdmin: '/registry',
  attachments: '/attachments'
} as const;
